// src/context/DrawerContext.js
import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const DrawerContext = createContext();

export const useDrawerContext = () => useContext(DrawerContext);

export const DrawerProvider = ({ children }) => {
  const [activeDrawer, setActiveDrawer] = useState(false);

  const openDrawer = () => {
    setActiveDrawer(true);
  };

  const closeDrawer = () => {
    setActiveDrawer(false);
  };

  const value = useMemo(
    () => ({ activeDrawer, openDrawer, setActiveDrawer, closeDrawer }),
    [activeDrawer]
  );

  return <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>;
};

DrawerProvider.propTypes = {
  children: PropTypes.node.isRequired
};
